import { useDispatch, useSelector } from 'react-redux';
export var useTypeSelector = useSelector;
export var useTypeDispatch = useDispatch;
